import { useState, useEffect } from 'react';
import { Alert, Spinner } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { UserRecordAttendanceWithTokenRequest } from 'cb-model';
import { fetchApi, PageTitle } from 'gossamer-front-end';
import { getGpsPosition } from '../location/getGpsPosition';

export const CaptureAttendanceQRCode = (): React.JSX.Element => {
  const [error, setError] = useState<string>('');
  const { attendanceToken } = useParams();
  const navigate = useNavigate();

  const handleRegisterAttendance = async () => {
    try {
      const gpsPos = await getGpsPosition(1200);
      const payload: UserRecordAttendanceWithTokenRequest = {
        attendanceToken,
        gpsStatus: gpsPos.gps_status,
        gpsLatitude: gpsPos.latitude,
        gpsLongitude: gpsPos.longitude,
      };
      const response = await fetchApi('POST', `/main/user-record-attendance-token`, payload);
      navigate(`/website/attend-success/${response.eventId}`);
    } catch (err) {
      console.error(`QR submit failed: ${err.error || err.message}`);
      setError(err.error || err.message || 'there is no network connection');
    }
  };

  useEffect(() => {
    if (!attendanceToken) {
      setError('No attendance token provided');
      return;
    }
    handleRegisterAttendance();
  }, [attendanceToken]);

  return (
    <div>
      <PageTitle title="Record Attendance using a QR Code" />
      {!error && <Spinner animation="border" size="sm" role="status" aria-hidden="true" />}
      {!!error && <Alert variant="danger">{error}</Alert>}
    </div>
  );
};
